import { createSelector } from '@reduxjs/toolkit';
import { getState } from '@yme/selectors/common';
const getFooterProperties = createSelector(getState, (state) => state.footer);
export const getFooterContent = createSelector([getFooterProperties], (footerProperties) => ({
    socialLinks: footerProperties.socialLinks,
    footerLabels: footerProperties.footerLabels,
}));
